import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=83cef5c4&scoped=true&"
import script from "./commission.ts?vue&type=script&lang=js&"
export * from "./commission.ts?vue&type=script&lang=js&"
import style0 from "./commission.scss?vue&type=style&index=0&id=83cef5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83cef5c4",
  null
  
)

export default component.exports